import { Component, OnInit, ElementRef, ViewChild, AfterViewInit, Inject } from '@angular/core';
import { fromEvent } from 'rxjs';
import anime from 'animejs/lib/anime.es.js';
import { distinctUntilChanged } from 'rxjs/operators';

const windowScrolled = fromEvent(window, 'scroll');

@Component({
  selector: 'app-business',
  templateUrl: './business.component.html',
  styleUrls: ['./business.component.scss']
})
export class BusinessComponent implements OnInit, AfterViewInit {
  vehiclesAnim;
  @ViewChild('vehicles', { static: false, read: ElementRef}) vehiclesRef: ElementRef;

  constructor(
    @Inject('VIEWPORT_WIDTH') private viewportWidth: any,
    @Inject('VIEWPORT_HEIGHT') private viewportHeight: any
  ) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    if (this.viewportWidth < 768) {
      this.vehiclesAnim = anime({
        targets: this.vehiclesRef.nativeElement,
        translateX: ['-50', '50'],
        easing: 'easeInOutSine',
        autoplay: false,
      });
    }

    windowScrolled
      .pipe(distinctUntilChanged())
      .subscribe(() => {
        if (this.viewportWidth < 768) {
          const vehiclesHeight = this.vehiclesRef.nativeElement.offsetHeight;
          const rect = this.vehiclesRef.nativeElement.getBoundingClientRect();
          const seekTime = (-rect.top + this.viewportHeight * 0.5) / vehiclesHeight;
          if (seekTime >= 0 && seekTime <= 1) {
            this.vehiclesAnim.seek(seekTime * this.vehiclesAnim.duration);
          }
        }
      });
  }

}
